module.exports = __webpack_public_path__ + "img/人体体姿测评.775693f8.png";